import { configureLogging, silenceConsole } from '@hunting-nature/shared-core/logging';

import { loggingConfigFor } from './app/shared/config/logging.config';
import { environment } from './environments/environment';

/**
 * Must be the first import in main.ts: modules log while they are evaluated, and those lines
 * must already see the final configuration — and, in prod, a silenced console.
 */
if (!environment.logging.console) {
  silenceConsole();
}

configureLogging(loggingConfigFor(environment.logging, globalThis.localStorage));
